import { api, API_BASE_URL } from './api'

export const cmsService = {
    getPage: (page) => api.get(`/cms/${page}`),
    updateSection: (page, section, data) => api.put(`/cms/${page}/${section}`, data),
    // Legacy aliases kept for AboutPage.jsx compatibility
    getAbout: () => api.get('/cms/about'),
    updateAboutSection: (section, data) => api.put(`/cms/about/${section}`, data),

    uploadCmsMedia: async (file) => {
        const formData = new FormData()
        formData.append('file', file)
        const token = localStorage.getItem('admin_token')
        const res = await fetch(`${API_BASE_URL}/cms/media/upload`, {
            method: 'POST',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
            body: formData,
        })
        if (!res.ok) {
            const err = await res.json().catch(() => ({ message: 'Upload failed' }))
            throw new Error(err.message || `HTTP ${res.status}`)
        }
        return res.json()
    },
}
